import { createRouter, createWebHistory } from "vue-router";

// Default Pages
import Dashboard from "../views/Dashboard.vue";

// Component Pages
import Partners from "../views/components/partners.vue";
import Services from "../views/components/Services.vue";
import Languages from "../views/components/Languages.vue";
import contactMessages from "../views/components/contact-messages.vue"
import freeTranslationRequests from "../views/components/free-translation-requests.vue";
import Articles from "../views/components/articles.vue";

 
// Auth Pages
import Login from "../views/layouts/auth/Login.vue";


// CRUD Pages
import AddPartners from "../pages/add-partners.vue";
import EditPartners from "../pages/edit-partners.vue";
import AddService from "../pages/add-service.vue";
import EditService from "../pages/edit-services.vue";
import AddLanguage from "../pages/addLanguage.vue";
import EditLanguage from "../pages/editLanguage.vue";
import AddArticle from "../pages/add-article.vue";
import EditArticle from "../pages/edit-article.vue";
// Layouts
//import Blank from "../views/layouts/Blank.vue";

// Error Pages
import Page404 from "../views/layouts/error/404.vue";
import Page500 from "../views/layouts/error/500.vue";
import PageMaintenance from "../views/layouts/error/maintenance.vue";

// Tables
import Tables from "../views/tables.vue";

const appname = " - TransGate Dashboard Admin Template";

const routes = [
  // Dashboard
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    meta: { title: "Dashboard" + appname },
  },
{
  path: "/login",
  component: () => import("@/pages/Login.vue"),
},
{
  path: "/forgot-password",
  component: () => import("@/pages/ForgotPassword.vue"),
},
{
  path: "/reset-password",
  component: () => import("@/pages/ResetPassword.vue"),
},

  // ------------------------------
  // 👩partners
  // ------------------------------
  {
    path: "/component/partners",
    name: "Partners",
    component: Partners,
    meta: { title: "Partners" + appname },
  },
  {
    path: "/pages/add-Partners",
    name: "AddPartners",
    component: AddPartners,
    meta: { title: "Add Partners" + appname },
  },
  {
    path: "/edit-partners/:id",
    name: "EditPartners",
    component: EditPartners,
    meta: { title: "Edit Partners" + appname },
  },

  //services

   {
    path: "/component/Services",
    name: "Services",
    component: Services,
    meta: { title: "Services" + appname },
  },
  {
    path: "/pages/add-service",
    name: "AddService",
    component: AddService,
    meta: { title: "Add Services" + appname },
  },
  {
    path: "/edit-services/:id",
    name: "EditService",
    component: EditService,
    meta: { title: "Edit Service" + appname },
  },

  //languages

  {
    path: "/component/Languages",
    name: "Languages",
    component: Languages,
  },
  {
    path: "/pages/addLanguage",
    name: "AddLanguage",
    component: AddLanguage,
  },
  {
    path: "/editLanguage/:id",
    name: "EditLanguage",
    component: EditLanguage,
    props: true,
  },

  //contactMessages
    {
    path: "/components/contact-messages",
    name: "contactMessages",
    component: contactMessages,
  },
  //free-translation-requests
  {
  path: "/components/free-translation-requests",
  name: "freeTranslationRequests",
  component: freeTranslationRequests,
},
//articles

   {
    path: "/components/articles",
    name: "Articles",
    component: Articles,
    meta: { title: "Articles" + appname },
  },
  {
  path: "/pages/add-article",
  name: "AddArticle",
  component: AddArticle,
},
{
  path: "/edit-article/:id",
  name: "EditArticle",
  component: EditArticle,
},

  

  // // ------------------------------
  // // 📄 Others
  // // ------------------------------
  // {
  //   path: "/Blank",
  //   name: "Blank",
  //   component: Blank,
  //   meta: { title: "Blank Page" + appname },
  // },
  // {
  //   path: "/tables",
  //   name: "Tables",
  //   component: Tables,
  //   meta: { title: "Tables" + appname },
  // },

  // ------------------------------
  // 🔐 Auth Pages
  // ------------------------------
  // {
  //   path: "/auth/login",
  //   name: "Login",
  //   component: Login,
  //   meta: { title: "Login" + appname, hideNav: true },
  // },
  // {
  //   path: "/auth/register",
  //   name: "Register",
  //   component: Register,
  //   meta: { title: "Register" + appname, hideNav: true },
  // },
  // {
  //   path: "/auth/forgot-password",
  //   name: "ForgotPassword",
  //   component: ForgotPassword,
  //   meta: { title: "Forgot Password" + appname, hideNav: true },
  // },

  // ------------------------------
  // ⚠️ Error Pages
  // ------------------------------
  {
    path: "/500",
    name: "Page500",
    component: Page500,
    meta: { title: "Server Error" + appname, hideNav: true },
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: PageMaintenance,
    meta: { title: "Maintenance Mode" + appname, hideNav: true },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Page404",
    component: Page404,
    meta: { title: "404 - Page Not Found" + appname, hideNav: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // 👈 رجعناه لـ process.env
  routes,
  linkExactActiveClass: "exact-active",
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  if (to.meta.requiresAuth && !token) {
    return next("/login");
  }

  next();
});


export default router;
